<template>
  <div>
    <card title="Select country">
      <el-select v-model="countryId"
                 placeholder="Countries"
                 no-data-text="No data"
                 no-match-text="No match"
                 filterable
                 reserve-keyword
                 value-key="id">
        <el-option v-for="country in countries"
                   :key="country.id"
                   :label="country.name.en"
                   :value="country.id">
        </el-option>
      </el-select>
    </card>
    <EntityTexts v-if="countryId" :data="texts"/>
  </div>
</template>

<script>
  import EntityTexts from '@/components/Entities/EntityTexts';
  import { mapActions, mapState } from 'vuex';

  export default {
    props: ['entitiesString'],
    data: () => ({
      countryId: null,
    }),
    components: {
      EntityTexts,
    },
    computed: {
      ...mapState('cmsApiCatalogs', ['countries']),
      defaultTexts() {
        if (this.$route.name === 'illness-kind') {
          return [
            { text: '', alias: 'txt_before_clinics'},
            { text: '', alias: 'txt_after_3_clinics'},
            { text: '', alias: 'txt_clinics'},
            { text: '', alias: 'txt_price'},
          ];
        } else {
          return [
            { text: '', alias: 'txt_country'},
            { text: '', alias: 'txt_clinics'},
            { text: '', alias: 'txt_after_3_clinics'},
            { text: '', alias: 'txt_price'},
            { text: '', alias: 'trust_block'},
          ];
        }
      },
      texts() {
        let defaultTexts = [...this.defaultTexts];
        const pushAliases = (aliases) => {
          aliases.forEach(alias => defaultTexts.push({ text: '', alias }));
        };
        if (this.$route.name === 'operation' || this.$route.name === 'illness') {
          pushAliases(['pros_cons_mc', 'country_hub']);
        }
        if (this.$route.name === 'operation') {
          pushAliases([
            'overview_table',
            'overview_text',
            'how_it_works',
            'diagnostic_text',
            'cities_table',
            'how_to_choose_text',
            'combined_procedures',
            'txt_timeline',
            'best_for',
            'itinerary',
            'price_factors',
            'price_faq',
            'packages_aio',
            'safety_consideration_text',
            'clinics_aio',
            'pros_cons_text',
            'doctors_aio',
            'before_after_aio',
            'reviews_aio',
            'satisfaction_text',
            'technique_aio',
            'technique_text',
            'city_aio',
            'city_text',
            'best_candidates_text',
            'travel_plan_faq',
            'package_price_include',
            'doctor_good_fit_for',
            'doctor_what_sets_them_apart',
            'doctor_consultation_price'
          ]);
        }

        return {
          getMethod: 'getEntityTextsConnection',
          saveMethod: 'saveEntityTextsConnection',
          translateMethod: 'translateEntityTextsConnection',
          forEntity: 'countries',
          forEntityId: this.countryId,
          entitiesString: this.$route.name === 'illness-kind' ? 'illnesses_kinds' : this.entitiesString,
          defaultTexts,
        };
      },
    },
    created() {
      this.getCountries({ perPage: 1500 });
    },
    methods: {
      ...mapActions('cmsApiCatalogs', ['getCountries']),
    }
  };
</script>
